import { useEffect, useState } from "react"
import { Link, NavLink } from "react-router-dom"
import axiosInstance from "../../hooks/axiosInstance"
import { toast } from "react-toastify"
import { Pagination } from "@mui/material"

export default function MyAssociationsPage() {
    const [loading, setLoading] = useState(false)
    const [associations, setAssociations] = useState([])
    const [currentAssociation, setCurrentAssociation] = useState(null)
    
    const [filter, setFilter] = useState({
        search: '', 
        status: '',
        membershipMode: '',
        membershipStatus: ''
    })

    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    
    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleFilterChange = (e) => {
        const {name, value} = e.target

    setFilter(prevFilter => (
            {...prevFilter, [name]: value}
        ))
    }

    const fetchUserAssociations = () => {
        setLoading(true)
        axiosInstance.post(`/user/associations?page=${page}`, filter)
              .then(response => {
                setAssociations(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    useEffect(() => {
        fetchUserAssociations()
    }, [page])
    
    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">My Associations</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">My Associations</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            <div className="row" id="contactList">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex align-items-center border-0">
                            <h5 className="card-title mb-0 flex-grow-1">My Associations</h5>
                            {/* <div className="flex-shrink-0">
                                <div className="flax-shrink-0 hstack gap-2">
                                    <button className="btn btn-primary">Today's Orders</button>
                                    <button className="btn btn-soft-info">Past Orders</button>
                                </div>
                            </div> */}
                        </div>
                        <div className="card-body border border-dashed border-end-0 border-start-0">
                            <div className="row g-2">
                                <div className="col-xl-4 col-md-6">
                                    <div className="search-box">
                                        <input 
                                            type="text" 
                                            className="form-control search" 
                                            placeholder="Search associations..." 
                                            name="search"
                                            value={filter.search}
                                            onChange={handleFilterChange}
                                        />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </div>
                                {/* <!--end col--> */}
                                {/* <div className="col-xl-3 col-md-6">
                                    <div className="input-group">
                                        <span className="input-group-text" id="basic-addon1"><i className="ri-calendar-2-line"></i></span>
                                        <input type="text" className="form-control" data-date-format="d M, Y" data-range-date="true" placeholder="Select date" id="range-datepicker" aria-describedby="basic-addon1" />
                                    </div>
                                </div> */}
                                {/* <!--end col--> */}
                                <div className="col-xl-2 col-md-4">
                                    <select 
                                        className="form-control" 
                                        name="membershipMode"
                                        value={filter.membershipMode}
                                        onChange={handleFilterChange} 
                                    >
                                        <option value="">Select Type</option>
                                        <option value="free">Free</option>
                                        <option value="paid">Paid</option>
                                    </select>
                                </div>
                                {/* <!--end col--> */}
                                <div className="col-xl-2 col-md-4">
                                    <select 
                                        className="form-control"
                                        name="status" 
                                        value={filter.status}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="open">Open</option>
                                        <option value="closed">Closed</option>
                                    </select>
                                </div>
                                <div className="col-xl-2 col-md-4">
                                    <select 
                                        className="form-control" 
                                        name="membershipStatus"
                                        value={filter.membershipStatus}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">Select Membership Status</option>
                                        <option value="active">Active</option>
                                        <option value="expired">Expired</option>
                                    </select>
                                </div>
                                {/* <!--end col--> */}
                                <div className="col-xl-1 col-md-4" onClick={fetchUserAssociations}>
                                    <button className="btn btn-success w-100" onclick="filterData();">Filter</button>
                                </div>
                            </div>
                            {/* <!--end row--> */}
                        </div>
                        <div className="card-body">
                            {associations.length > 0 && (
                                <>
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle table-nowrap" id="customerTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th className="sort" data-sort="currency_name" scope="col">Association Info</th>
                                                    <th className="sort" data-sort="type" scope="col">Membership Type</th>
                                                    <th className="sort" data-sort="quantity_value" scope="col">Membership ID</th>
                                                    <th className="sort" data-sort="time" scope="col">Date Joined</th>
                                                    <th className="sort" data-sort="status" scope="col">Status</th>
                                                    <th className="sort" data-sort="status" scope="col">Membership Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            {/* <!--end thead--> */}
                                            <tbody className="list form-check-all">
                                                {associations.map(association => (
                                                    <tr key={association.id}>
                                                        <td className="id" style={{display:"none"}}>
                                                            <a className="fw-medium link-primary">{association.members[0]?.membership_id}</a>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-shrink-0">
                                                                    <img src="/assets/images/svg/crypto-icons/btc.svg" alt="" className="avatar-xs" />
                                                                </div>
                                                                <NavLink to={`/app/associations/${association.id}`} className="flex-grow-1 ms-2 currency_name">
                                                                    <span className="m-0">{association.name}</span>
                                                                    <p className="m-0 text-muted" style={{lineHeight: 1.5}}>{association.email}</p>
                                                                </NavLink>
                                                            </div>
                                                        </td>
                                                        <td className={`type ${association.membership_mode == 'free' ? 'text-success' : 'text-danger'} text-capitalize`}>
                                                            {association.membership_mode}
                                                        </td>
                                                        <td className="id fw-medium link-primary">{association.members[0]?.membership_id ? association.members[0]?.membership_id : '-'}</td>
                                                        <td className="order_date time" data-timestamp="1641945600">
                                                            {association.members[0]?.joined_on}
                                                        </td>
                                                        <td className="status">
                                                            <span className={`badge ${association.membership_status == 'open' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                                                                } text-uppercase`}
                                                            >{association.membership_status}</span>
                                                        </td>
                                                        <td className="status">
                                                            <span className={`badge ${association.members[0].status == 'active' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                                                                } text-uppercase`}
                                                            >Active</span>
                                                        </td>
                                                        <td>
                                                            <div className="dropdown">
                                                                <button className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="ri-more-fill"></i>
                                                                </button>
                                                                <ul className="dropdown-menu">
                                                                    <li><NavLink className="dropdown-item" to={`/app/associations/${association.id}`}>
                                                                        <i className="ri-eye-fill text-muted me-2 align-bottom"></i>Go to Association
                                                                        </NavLink>
                                                                    </li>
                                                                    {/* <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-star-fill text-muted me-2 align-bottom"></i>Renew Membership</a></li> */}
                                                                    {/* <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-delete-bin-5-fill text-muted me-2 align-bottom"></i>Leave</a></li> */}
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {/* <!--end table--> */}
                                        <div className="noresult" style={{display: "none"}}>
                                            <div className="text-center">
                                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                                <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                                        {/* <div className="col-sm-6">
                                            <div>
                                                <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                                            </div>
                                        </div> */}
                                        {/* <!-- end col --> */}
                                        <div className="col-sm-12 d-flex justify-content-end mt-4">
                                            <Pagination 
                                                onChange={handlePageChange}  
                                                count={pageCount} 
                                                color="primary" 
                                                shape="rounded"
                                                size="small"
                                                page={page}
                                            />
                                        </div>
                                        {/* <!-- end col --> */}
                                    </div>
                                </>
                            )}
                            {associations.length == 0 && (
                                <div className="noresult">
                                    <div className="text-center">
                                        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                        <h5 className="mt-2">Sorry! No Result Found</h5>
                                        {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <!--end card--> */}
                </div>
                {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}
        </>
    )
}